import {
    SET_BRAND_ID,
    SET_URL,
    SET_SHOW_POWERED_BY,
    SET_PRIMARY_COLOR,
    SET_SECONDARY_COLOR,
    SET_ICON_PRIMARY_COLOR,
    SET_ICON_SECONDARY_COLOR,
    SET_FONT_COLOR,
    SET_BRAND_LOADING_STATUS,
    SET_IMAGES
} from '@/store/modules/brand/mutations'

import BrandApi from '@/api/BrandApi'
import OrganizationApi from '@/api/OrganizationApi'
import BrandService from '@/services/BrandService'
import { normalizeData } from '@/helpers/Utils'

const brandApi = new BrandApi()
const organizationApi = new OrganizationApi()

const setBranding = async ({ commit, dispatch, rootGetters }, payload) => {
    commit(SET_BRAND_LOADING_STATUS, true)

    const permissions = rootGetters['authModule/getPermissions'].toString().split(',')
    if (!permissions.includes('1') && !permissions.includes('400')) {
        dispatch('clearBranding')
        return
    }

    const organization = await organizationApi.getOrganizationById(localStorage.getItem('activeOrganization'))
    if (!organization.isSuccess) {
        dispatch('clearBranding')
        return
    }
    if (!organization.payload.organizationBrandId) {
        dispatch('clearBranding')
        return
    }

    const branding = await brandApi.getBrandById(localStorage.getItem('activeOrganization'))
    if (!branding.isSuccess) {
        dispatch('clearBranding')
        return
    }

    commit(SET_BRAND_ID, branding.payload.id)
    commit(SET_URL, branding.payload.url)
    commit(SET_SHOW_POWERED_BY, branding.payload.showPoweredBy)
    commit(SET_PRIMARY_COLOR, branding.payload.primaryColor)
    commit(SET_SECONDARY_COLOR, branding.payload.secondaryColor)
    commit(SET_ICON_PRIMARY_COLOR, branding.payload.iconPrimaryColor)
    commit(SET_ICON_SECONDARY_COLOR, branding.payload.iconSecondaryColor)
    commit(SET_FONT_COLOR, branding.payload.fontColor)
    commit(SET_IMAGES, normalizeData(branding.payload.images, 'type'))

    BrandService.setGlobalColors(
        branding.payload.primaryColor,
        branding.payload.secondaryColor,
        branding.payload.fontColor,
        branding.payload.iconPrimaryColor,
        branding.payload.iconSecondaryColor
    )
    commit(SET_BRAND_LOADING_STATUS, false)
}

const clearBranding = ({ commit }, payload) => {
    BrandService.resetGlobalColors()

    commit(SET_BRAND_ID, null)
    commit(SET_URL, null)
    commit(SET_SHOW_POWERED_BY, null)
    commit(SET_PRIMARY_COLOR, null)
    commit(SET_SECONDARY_COLOR, null)
    commit(SET_ICON_PRIMARY_COLOR, null)
    commit(SET_ICON_SECONDARY_COLOR, null)
    commit(SET_FONT_COLOR, null)
    commit(SET_BRAND_LOADING_STATUS, false)
    commit(SET_IMAGES, {})
}

export default {
    setBranding,
    clearBranding
}
